<template>
  <div class="payouts-history-table">
    <CDataTable
      :items="payouts"
      :fields="fields"
      class="table-payout"
      :no-items-view="{ noResults: $pgettext('payout.history', 'Nessun pagamento nello storico') }"
    >
      <!-- Periodo -->
      <template #period="{item}">
       <td class="font-weight-medium text-nowrap">
          {{ (item.paid_at || item.date_from) | formatDate('MMMM YYYY') }}
        </td>
      </template>

      <!-- Importo Netto -->
      <template #paid_net="{item}">
        <td>
          <div class="font-weight-medium text-nowrap">
            {{ item.paid_net | currency(item.currency) }}
          </div>
        </td>
      </template>

      <!-- Stato -->
      <template #status="{item}">
        <td>
          <CBadge color="success" class="px-3 py-1 badge-outline">
            <translate translate-context="payout.history">Paid</translate>
          </CBadge>
        </td>
      </template>

      <!-- Fattura -->
      <template #invoice="{item}">
        <td>
          <CLink
            v-if="item.invoice"
            :href="item.invoice"
            target="_blank"
            class="d-flex align-items-center text-truncate link-invoice"
          >
            <CIcon name="cipDoc" size="sm" class="mr-1 flex-shrink-0" />
            <span class="text-truncate">{{ item.invoice_name || 'Invoice' }}</span>
          </CLink>
          <span v-else class="text-muted">---</span>
        </td>
      </template>

      <!-- Details slot (expanded row) -->
      <template #details="{item}">
        <CCollapse :show="isExpanded(item.id)">
          <div class="p-3">
            <template v-if="getExpandedData(item.id)">
              <PayoutEventDetail
                v-if="getExpandedData(item.id).pica_services && getExpandedData(item.id).pica_services.length > 0"
                :pica-services="getExpandedData(item.id).pica_services"
                :currency="getExpandedData(item.id).currency || 'EUR'"
                @download="$emit('download-payout-excel', item)"
              />
              <div v-else class="text-center py-3 text-muted">
                <translate translate-context="payout.history">No details available</translate>
              </div>
            </template>
            <div v-else class="text-center py-3">
              <CSpinner size="sm" color="primary" />
            </div>
          </div>
        </CCollapse>
      </template>

   <template #action="{item}">
        <!-- Chevron expand -->
        <td class="text-right">
          <div>
            <CLink @click="onToggleRow(item.id)" class="cursor-pointer">
              <CIcon
                :name="isExpanded(item.id) ? 'cipChevronDown' : 'cipChevronRight'"
                size="custom-size"
                :height="18"
              />
            </CLink>
          </div>
          </td>
      </template>
    </CDataTable>
  </div>
</template>

<script>
import PayoutEventDetail from './PayoutEventDetail.vue'
export default {
  name: 'PayoutsHistoryTable',
  components: {
    PayoutEventDetail
  },
  props: {
    payouts: {
      type: Array,
      required: true
    },
    expandedData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      expandedRows: [],
      fields: [
        {
          key: 'period',
          label: this.$pgettext('payout.history', 'PERIODO'),
          _style: 'width: 200px'
        },
        {
          key: 'paid_net',
          label: this.$pgettext('payout.history', 'IMPORTO NETTO'),
          _style: 'width: 150px'
        },
        {
          key: 'status',
          label: this.$pgettext('payout.history', 'STATO'),
          _style: 'width: 120px'
        },
        {
          key: 'invoice',
          label: this.$pgettext('payout.history', 'FATTURA'),
          _style: 'width: 200px'
        },
         {
          key: 'action',
          label: '',
          _style: 'width: 100px'
        }
      ]
    }
  },
  methods: {
    onToggleRow(id) {
      const idx = this.expandedRows.indexOf(id)
      if (idx > -1) {
        this.expandedRows.splice(idx, 1)
      } else {
        this.expandedRows.push(id)
        this.$emit('expand', id)
      }
    },
    isExpanded(id) {
      return this.expandedRows.includes(id)
    },
    getExpandedData(id) {
      return this.expandedData[id] || null
    },

    formatCompletedNote(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const formatted = new Intl.DateTimeFormat('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date)
      return `Completed on ${formatted}`
    }
  }
}
</script>

<style scoped>
.payouts-history-table :deep(.table td) {
  vertical-align: middle;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
